/*if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.buttons = this.querySelectorAll('.full-menu--link-parent');
      this.header = this.closest('.header');
      this.subButtons = this.querySelectorAll('.full-menu--link-child');
      this.panel = this.querySelector('.full-menu--panel');
      this.panel1 = this.querySelector('.full-menu--panel--level-1');
      this.panel2 = this.querySelector('.full-menu--panel--level-2');
      this.cc = this.querySelector('.full-menu--cc');
      this.toggle = this.querySelector('.full-menu--toggle');
      this.panelWidth = 320;
    }
    connectedCallback() {
      this.buttons.forEach((button, i) => {
        button.addEventListener('click', (e) => this.onParentHover(button, e, i));
        button.addEventListener('keydown', (e) => this.onParentKeydown(button, e, i));
        button.addEventListener('focus', (e) => this.onParentFocus(button, e, i));
      });
      this.subButtons.forEach((button, i) => {
        button.addEventListener('click', (e) => this.onChildHover(button, e, i));
      });
      this.panel2.addEventListener('click', this.onPanelLeave.bind(this));
      this.toggle.addEventListener('click', this.onToggleClick.bind(this));
      this.cc.addEventListener('click', this.onCC.bind(this));

      this.addEventListener('blur', this.onCC.bind(this));
      document.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.onCC();
        }
      });
    }
    onParentFocus() {
      this.header.classList.add('open-menu');
    }
    onParentKeydown(button, e, i) {
      if (e.code.toUpperCase() !== 'ENTER') return;

      if (button.classList.contains('has-sub-menu')) {
        let submenus = this.panel1.querySelectorAll('.full-menu--subpanel'),
          target_selector = button.dataset.target;
        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');

        [].forEach.call(submenus, function (el) {
          el.classList.remove('active');
        });
        this.panel1.querySelector(target_selector).classList.add('active');
        this.panel1.querySelector(target_selector).querySelectorAll('a')[0].focus();
      }
    }
    onParentHover(button, e, i) {
      this.header.classList.add('open-menu');

      if (button.classList.contains('has-sub-menu')) {
        let submenus = this.panel1.querySelectorAll('.full-menu--subpanel'),
          target_selector = button.dataset.target;
        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');

        [].forEach.call(submenus, function (el) {
          el.classList.remove('active');
        });
        this.panel1.querySelector(target_selector).classList.add('active');
      } else {
        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 1) + 'px');
      }
      window.dispatchEvent(new Event('resize'));
      e.preventDefault();
    }
    onChildHover(button, e, i) {
      if (button.classList.contains('has-sub-menu')) {
        let submenus = this.panel2.querySelectorAll('.full-menu--subpanel'),
          target_selector = button.dataset.target;

        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 3) + 'px');
        [].forEach.call(submenus, function (el) {
          el.classList.remove('active');
        });
        this.panel2.querySelector(target_selector).classList.add('active');
      } else {
        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');
      }

      // e.preventDefault();
    }
    onPanelLeave() {
      this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');
    }
    onToggleClick() {
      this.header.classList.add('open-menu');
    }
    onCC() {
      this.panel.style.setProperty('--menu-panel-width', (this.panelWidth) + 'px');
      [].forEach.call(this.panel, function (el) {
        el.classList.remove('active');
      });
      this.header.classList.remove('open-menu');
    }
  }
  customElements.define('full-menu', FullMenu);
}*/

if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.buttons = this.querySelectorAll('.full-menu--link-parent');
      this.header = this.closest('.header');
      this.subButtons = this.querySelectorAll('.full-menu--link-child');
      this.panel = this.querySelector('.full-menu--panel');
      this.panel1 = this.querySelector('.full-menu--panel--level-1');
      this.panel2 = this.querySelector('.full-menu--panel--level-2');
      this.cc = this.querySelector('.full-menu--cc');
      this.toggle = this.querySelector('.full-menu--toggle');
      this.panelWidth = 320;
    }

    connectedCallback() {
      this.buttons.forEach((button, i) => {
        button.addEventListener('click', (e) => this.onParentHover(button, e, i));
        button.addEventListener('keydown', (e) => this.onParentKeydown(button, e, i));
        button.addEventListener('focus', (e) => this.onParentFocus(button, e, i));
      });

      this.subButtons.forEach((button, i) => {
        button.addEventListener('click', (e) => this.onChildHover(button, e, i));
      });

      this.panel2.addEventListener('click', this.onPanelLeave.bind(this));
      this.toggle.addEventListener('click', this.onToggleClick.bind(this));
      this.cc.addEventListener('click', this.onCC.bind(this));

      this.addEventListener('blur', this.onCC.bind(this));

      document.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.onCC();
        }
      });
    }

    onParentFocus() {
      this.header.classList.add('open-menu');
    }

    onParentKeydown(button, e, i) {
      if (e.code.toUpperCase() !== 'ENTER') return;

      if (button.classList.contains('has-sub-menu')) {
        let submenus = this.panel1.querySelectorAll('.full-menu--subpanel'),
            target_selector = button.dataset.target;

        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');

        submenus.forEach((el) => el.classList.remove('active'));

        const targetPanel = this.panel1.querySelector(target_selector);

        if (targetPanel) {
          targetPanel.classList.add('active');
          targetPanel.querySelectorAll('a')[0].focus();
        }
      }
    }

    onParentHover(button, e, i) {
      this.header.classList.add('open-menu');

      if (button.classList.contains('has-sub-menu')) {
        let submenus = this.panel1.querySelectorAll('.full-menu--subpanel'),
            target_selector = button.dataset.target;

        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');

        submenus.forEach((el) => el.classList.remove('active'));

        const targetPanel = this.panel1.querySelector(target_selector);

        if (targetPanel) {
          targetPanel.classList.add('active');
        }
      } else {
        this.panel.style.setProperty('--menu-panel-width', this.panelWidth + 'px');
      }

      window.dispatchEvent(new Event('resize'));
      e.preventDefault();
    }

    onChildHover(button, e, i) {
      if (!this.panel2 || !this.panel) return;

      if (button.classList.contains('has-sub-menu')) {
        let submenus = this.panel2.querySelectorAll('.full-menu--subpanel'),
            target_selector = button.dataset.target;

        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 3) + 'px');

        submenus.forEach((el) => el.classList.remove('active'));

        const targetPanel = this.panel2.querySelector(target_selector);

        if (targetPanel) {
          targetPanel.classList.add('active');
        }
      } else {
        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');
      }
    }

    onPanelLeave() {
      this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');
    }

    onToggleClick() {
      this.header.classList.add('open-menu');

      // 👉 OPEN FIRST MENU ONLY WHEN DRAWER OPENS
      this.openDefaultMenu();
    }

    openDefaultMenu() {
      const firstButton = this.buttons[0];

      if (!firstButton || !this.panel1 || !this.panel) return;

      if (firstButton.classList.contains('has-sub-menu')) {
        let submenus = this.panel1.querySelectorAll('.full-menu--subpanel'),
            target_selector = firstButton.dataset.target;

        this.panel.style.setProperty('--menu-panel-width', (this.panelWidth * 2) + 'px');

        submenus.forEach((el) => el.classList.remove('active'));

        const targetPanel = this.panel1.querySelector(target_selector);

        if (targetPanel) {
          targetPanel.classList.add('active');
        }
      } else {
        this.panel.style.setProperty('--menu-panel-width', this.panelWidth + 'px');
      }

      window.dispatchEvent(new Event('resize'));
    }

    onCC() {
      if (!this.panel) return;

      this.panel.style.setProperty('--menu-panel-width', this.panelWidth + 'px');

      this.panel1.querySelectorAll('.full-menu--subpanel')
        .forEach((el) => el.classList.remove('active'));

      this.panel2.querySelectorAll('.full-menu--subpanel')
        .forEach((el) => el.classList.remove('active'));

      this.header.classList.remove('open-menu');

      window.dispatchEvent(new Event('resize'));
    }
  }

  customElements.define('full-menu', FullMenu);
}

